var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header"},[(_vm.isContentDivisorVisible)?_c('ContentDivisor',{staticClass:"divisor"}):_vm._e(),_c('PrimaryTitle',[_vm._t("title")],2),(_vm.$slots.subtitle)?_c('SecondaryTitle',{staticClass:"subtitle"},[_vm._t("subtitle")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }